import gql from 'graphql-tag'
export interface LoginInput {
  email: string
  password: string
}

export interface SelectionOnUser {
  id: string
}

export interface SelectionOnLogin {
  token: string
  user: SelectionOnUser
}

export interface Login {
  login: SelectionOnLogin
}

export default gql`
  mutation Login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      token
      user {
        id
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/mutations/login.tsx